import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PushNotificationLinkComponent } from './push-notification-link/push-notification-link.component';
import { PushNotificationComponent } from './push-notification/push-notification.component';

const routes: Routes = [
    {
          path:'',component:PushNotificationLinkComponent,
          children:[
            {
              path:"Notification", component:PushNotificationComponent
            },  
          ]
        }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PushNotificationRoutingModule { }
